import React from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;
const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const commonCss = config.css.commonDevice;

const SMALL_PADDING_HEIGHT = commonCss.textButton.smallPaddingTop;
const SMALL_PADDING_WIDTH = commonCss.textButton.smallPaddingRight;
const NORMAL_PADDING_HEIGHT = commonCss.textButton.normalPaddingTop;
const NORMAL_PADDING_WIDTH = commonCss.textButton.normalPaddingRight;
const LARGE_PADDING_HEIGHT = commonCss.textButton.largePaddingTop;
const LARGE_PADDING_WIDTH = commonCss.textButton.largePaddingRight;

const TextButton = withStyles({
  root: {
    minWidth: 0,
    minHeight: 0,
    lineHeight: commonCss.textButton.lineHeightOfTextBtn,
    "&:hover": {
      backgroundColor: "inherit"
    }
  }
})(Button);

TextButtonView.propTypes = {
  design: PropTypes.oneOf(["select", "unselect", "default"]),
  /** "unselect"는 deprecated. 현재 "unselect"와 "defalut"의 결과 같다. */

  paddingSize: PropTypes.oneOf(["small", "normal", "large"]),
  fontSize: PropTypes.number,
  forAccountPanel: PropTypes.bool,
  fontColor: PropTypes.string,
  fontWeight: PropTypes.number,
  disabled: PropTypes.bool,
  disableLeftMargin: PropTypes.bool,
  disableRightMargin: PropTypes.bool,
  disableTopMargin: PropTypes.bool,
  disableBottomMargin: PropTypes.bool,
  wordBreakCenter: PropTypes.bool,
  wordBreakLeft: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

TextButtonView.defaultProps = {
  design: "default",
  paddingSize: "normal",
  fontSize:
    getDeviceType() === "mobile"
      ? mobileCss.fontSizeOfTextBtn
      : desktopCss.fontSizeOfTextBtn,
  forAccountPanel: false,
  fontColor: null,
  fontWeight: fontCss.medium,
  desabled: false,
  disableLeftMargin: false,
  disableRightMargin: false,
  disableTopMargin: false,
  disableBottomMargin: false,
  wordBreakCenter: false,
  wordBreakLeft: false
};

function TextButtonView(props) {
  const {
    design,
    paddingSize,
    fontSize,
    forAccountPanel,
    fontColor,
    fontWeight,
    disabled,
    disableLeftMargin,
    disableRightMargin,
    disableTopMargin,
    disableBottomMargin,
    wordBreakCenter,
    wordBreakLeft,
    onClick
  } = props;
  const { children } = props;

  const getButtonTagType = () => {
    const style = { fontSize, fontWeight };

    if (forAccountPanel) {
      style.fontSize =
        getDeviceType() === "mobile"
          ? mobileCss.fontSizeOfAccountPanelBtn
          : desktopCss.fontSizeOfAccountPanelBtn;
    }

    const paddingHeight =
      paddingSize === "large"
        ? LARGE_PADDING_HEIGHT
        : paddingSize === "small"
        ? SMALL_PADDING_HEIGHT
        : NORMAL_PADDING_HEIGHT;
    const paddingWidth =
      paddingSize === "large"
        ? LARGE_PADDING_WIDTH
        : paddingSize === "small"
        ? SMALL_PADDING_WIDTH
        : NORMAL_PADDING_WIDTH;

    style.paddingTop = paddingHeight;
    style.paddingBottom = paddingHeight;
    style.paddingRight = paddingWidth;
    style.paddingLeft = paddingWidth;
    if (disableLeftMargin) style.marginLeft = -paddingWidth;
    if (disableRightMargin) style.marginRight = -paddingWidth;
    if (disableTopMargin) style.marginTop = -paddingHeight;
    if (disableBottomMargin) style.marginBottom = -paddingHeight;
    if (fontColor) style.color = fontColor;
    if (wordBreakCenter) {
      style.whiteSpace = "normal";
      style.wordBreak = "break-all";
    }
    if (wordBreakLeft) {
      style.whiteSpace = "normal";
      style.wordBreak = "break-all";
      style.textAlign = "left";
    }

    return (
      <TextButton
        variant="text"
        color={design === "select" ? "primary" : "default"}
        style={style}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </TextButton>
    );
  };

  return getButtonTagType();
}

export default TextButtonView;
